import TAXApi from './_taxApi';
import httpClient from '@/apis/base/httpclient';

class OrganizationHaveRiskAPI extends TAXApi {
  constructor() {
    super();
  }
  controllerName = 'OrganizationHaveRisks';
}

export default new OrganizationHaveRiskAPI();
